import { z } from 'zod';

export const CashFlowInflowSchema = z.object({
  id: z.string(),
  label: z.string(),
  amount: z.number().default(0),
  confidence: z.number().min(0).max(1).default(1),
  source: z.enum(['ar', 'deal', 'manual', 'recurring']).default('manual'),
  linkedId: z.string().nullable().default(null), // FK to client/deal if source != manual
});
export type CashFlowInflow = z.infer<typeof CashFlowInflowSchema>;

export const CashFlowOutflowSchema = z.object({
  id: z.string(),
  label: z.string(),
  amount: z.number().default(0),
  recurringId: z.string().nullable().default(null),
});
export type CashFlowOutflow = z.infer<typeof CashFlowOutflowSchema>;

export const CashFlowWeekSchema = z.object({
  weekStart: z.string(), // YYYY-MM-DD (Monday)
  inflows: z.array(CashFlowInflowSchema).default([]),
  outflows: z.array(CashFlowOutflowSchema).default([]),
  notes: z.string().default(''),
});
export type CashFlowWeek = z.infer<typeof CashFlowWeekSchema>;

export const RecurringOutflowSchema = z.object({
  id: z.string(),
  label: z.string(),
  amount: z.number().default(0),
  frequency: z.enum(['weekly', 'bi-weekly', 'monthly', 'quarterly']),
});
export type RecurringOutflow = z.infer<typeof RecurringOutflowSchema>;

export const CashFlowSchema = z.object({
  startingBalance: z.number().default(0),
  asOfDate: z.string().nullable().default(null),
  weeks: z.array(CashFlowWeekSchema).default([]),
  scenarios: z.object({
    conservative: z.number().default(0.65),
    likely: z.number().default(0.85),
    aggressive: z.number().default(1.0),
  }).prefault({}), // zod 4: prefault parses {} so the inner defaults fill in, as v3 .default did
  activeScenario: z.enum(['conservative', 'likely', 'aggressive']).default('likely'),
  recurringOutflows: z.array(RecurringOutflowSchema).default([]),
});
export type CashFlow = z.infer<typeof CashFlowSchema>;
